module.exports = __webpack_public_path__ + "c24bb4e304dc7839cadc39330fa4c31a.pdf";